/**
 * Sorprendeme - Template Selector for Donation Page
 *
 * **Stripe-only para todos los países, incluida Argentina** (ver
 * `src/lib/paymentProviderPolicy.ts`). MercadoPago fue retirado del checkout;
 * ya no existe la variante `SorprendemeTemplate` (brick MP).
 *
 * Performance optimizations:
 * - Lazy loading of templates for code splitting
 * - Minimal loading screen to reduce LCP
 */

import { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";

// Lazy load template for code splitting (reduces initial bundle size)
const SorprendemeStripeTemplate = lazy(() =>
  import("@/components/templates/SorprendemeStripeTemplate")
);

// Minimal loading screen (avoids CLS and improves perceived performance)
function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-500/20 via-purple-500/20 to-blue-500/20">
      <div className="text-center space-y-4">
        <Loader2 className="w-12 h-12 animate-spin text-pink-400 mx-auto" />
        <p className="text-white/80 text-sm">Cargando...</p>
      </div>
    </div>
  );
}

export default function Sorprendeme() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <SorprendemeStripeTemplate />
    </Suspense>
  );
}
